import { useQuery } from '@tanstack/react-query';
import { supabaseBlogService, SupabaseBlogPost, BlogPostsParams, BlogPostsResponse, BlogStats } from '@/services/supabaseBlogService';

export const useSupabaseBlogPosts = (params: BlogPostsParams = {}) => {
  return useQuery<BlogPostsResponse>({
    queryKey: ['supabase-blog-posts', 'v2', params], // v2 forces cache invalidation
    queryFn: () => supabaseBlogService.fetchPosts(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    refetchOnMount: true, // Force fresh fetch on mount
    retry: 1, // Retry once on failure
  });
};

export const useSupabaseBlogPost = (slug: string) => {
  return useQuery({
    queryKey: ['supabase-blog-post', 'v2', slug], // v2 forces cache invalidation
    queryFn: () => supabaseBlogService.fetchPost(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useSupabaseBlogCategories = () => {
  return useQuery({
    queryKey: ['supabase-blog-categories', 'v2'], // v2 forces cache invalidation
    queryFn: () => supabaseBlogService.fetchCategories(),
    staleTime: 15 * 60 * 1000, // 15 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  });
};

export const useSupabaseBlogStats = () => {
  return useQuery<BlogStats>({
    queryKey: ['supabase-blog-stats', 'v2'],
    queryFn: () => supabaseBlogService.fetchStats(),
    staleTime: 1 * 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
};
